import React from 'react'
import { motion } from 'framer-motion'
import { FaClipboardList, FaHeartbeat, FaRunning, FaUtensils, FaUserMd, FaBullseye } from 'react-icons/fa'
import { CheckCircle, Activity, Ruler } from 'lucide-react'
import { BottomSheet } from 'components/commons/BottomSheet'

export const FreeConsultationGuide = ({ isOpen, setIsShowConsultationDetails, quickBookPT }) => {

  const handleClose = () => setIsShowConsultationDetails(false)

  return (
    <BottomSheet 
      isOpen={isOpen} 
      onClose={handleClose}
      maxWidth="2xl"
      maxHeight="88vh"
    >
      {/* Header */}
      <BottomSheet.Header>
        <BottomSheet.Title>Free Consultation Details</BottomSheet.Title>
        <BottomSheet.Subtitle>A comprehensive personalised fitness plan</BottomSheet.Subtitle>
      </BottomSheet.Header>

      {/* Content */}
      <BottomSheet.Content>
        <div className="space-y-6 text-gray-700">
          <h4 className="text-base md:text-lg text-center">
            <span className="text-orange-500">✨</span> What&apos;s Included in Your Free Consultation
          </h4>
          {/* What's Included Section */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div className="flex items-start gap-3 bg-white/70 rounded-xl p-3">
              <div className="bg-orange-100 text-orange-600 p-2 rounded-full shrink-0">
                <FaBullseye size={16} />
              </div>
              <div>
                <h5 className="font-semibold text-sm text-gray-800">Goal & Requirements Discussion</h5>
                <p className="text-xs text-gray-500">Understand your fitness goals, expectations, preferred training style and timeline with a certified trainer</p>
              </div>
            </div>

            <div className="flex items-start gap-3 bg-white/70 rounded-xl p-3">
              <div className="bg-red-100 text-red-600 p-2 rounded-full shrink-0">
                <FaUserMd size={16} />
              </div>
              <div>
                <h5 className="font-semibold text-sm text-gray-800">Health History & Medical Review</h5>
                <p className="text-xs text-gray-500">Review of medical conditions, past injuries, surgeries, medications and any physical limitations</p>
              </div>
            </div>

            {/* <div className="flex items-start gap-3 bg-white/70 rounded-xl p-3">
              <div className="bg-blue-100 text-blue-600 p-2 rounded-full shrink-0">
                <FaHeartbeat size={16} />
              </div>
              <div>
                <h5 className="font-semibold text-sm text-gray-800">Physical & Fitness Assessment</h5>
                <p className="text-xs text-gray-500">Evaluate your current fitness level, posture, mobility, flexibility and movement patterns</p>
              </div>
            </div>

            <div className="flex items-start gap-3 bg-white/70 rounded-xl p-3">
              <div className="bg-green-100 text-green-600 p-2 rounded-full shrink-0">
                <Ruler size={16} />
              </div>
              <div>
                <h5 className="font-semibold text-sm text-gray-800">Body Composition Analysis</h5>
                <p className="text-xs text-gray-500">Baseline measurements including BMI, body fat percentage and key body measurements for tracking progress</p>
              </div>
            </div> */}

            <div className="flex items-start gap-3 bg-white/70 rounded-xl p-3">
              <div className="bg-purple-100 text-purple-600 p-2 rounded-full shrink-0">
                <FaUtensils size={16} />
              </div>
              <div>
                <h5 className="font-semibold text-sm text-gray-800">Diet & Lifestyle Review</h5>
                <p className="text-xs text-gray-500">Assess daily eating habits, nutrition intake, sleep quality, stress levels and overall lifestyle factors</p>
              </div>
            </div>

            <div className="flex items-start gap-3 bg-white/70 rounded-xl p-3">
              <div className="bg-amber-100 text-amber-600 p-2 rounded-full shrink-0">
                <FaClipboardList size={16} />
              </div>
              <div>
                <h5 className="font-semibold text-sm text-gray-800">Personalised Recommendations</h5>
                <p className="text-xs text-gray-500">Receive an initial training program outline, nutrition guidance and a tailored plan to achieve your goals</p>
              </div>
            </div>
          </div>
        </div>    
      </BottomSheet.Content>

      {/* Footer CTA */}
      <BottomSheet.Footer className="flex gap-3 shrink-0">
        <BottomSheet.CloseButton variant="secondary">
          Close
        </BottomSheet.CloseButton>
        <motion.button
          type="button"
          role="button"
          aria-label="Book free personal training consultation"
          title="Book free personal training consultation"
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          onClick={() => {
            quickBookPT("Fitness Trainer", "Personal training free consultation")
            handleClose()
          }}
          className="flex-1 bg-linear-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white font-semibold px-4 py-3 rounded-xl shadow-lg transition"
        >
          Claim Consultation
        </motion.button>
      </BottomSheet.Footer>
    </BottomSheet>
  )
}
